import React from "react";
import { SimpleTextInputCard } from "sortation/components/SimpleTextInputCard";
import { useZoneSkipArrivalScan } from "./useZoneSkipArrivalScan";

export const ZoneSkipArrivalScan = () => {
  const { barcode, isLoading, setBarcode, handleZoneSkipArrivalScan } = useZoneSkipArrivalScan();

  return (
    <SimpleTextInputCard
      title="Scan Gaylord Barcode"
      label="Gaylord ID"
      value={barcode}
      onSubmit={handleZoneSkipArrivalScan}
      onChange={setBarcode}
      disabled={isLoading}
      debounceSubsequent
    />
  );
};
